import { render, staticRenderFns } from "./LabPage.vue?vue&type=template&id=54ac03ff&scoped=true&"
import script from "./LabPage.vue?vue&type=script&lang=ts&"
export * from "./LabPage.vue?vue&type=script&lang=ts&"
import style0 from "./LabPage.vue?vue&type=style&index=0&id=54ac03ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac03ff",
  null
  
)

export default component.exports